export default { options: { label: 'Fairplay' } }
